export default __webpack_public_path__ + "static/media/release-notes.f855cfab.md";